export enum FeatureToggle {
  GuestManagementEnhancements = 'rt_guest_management_enhancements',
  UserGrantAppeasements = 'rt_guest_management_appeasements',
}
